// src/pages/Login.jsx
//
// HelpDesk ya no tiene su propio formulario de login -- todo pasa por el
// login central (login.bunzlsa.com), que ofrece SSO Microsoft o cuenta
// local en una sola pantalla y termina en el mismo mecanismo de
// "constancia firmada" que ya canjea /sso-callback (SsoCallback.jsx, sin
// cambios de ese lado). Esta pantalla solo existe como punto de rebote
// para quien llegue a /login directo (ProtectedRoute redirige acá, y
// desde acá se sigue de largo al login central).
import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LOGIN_CENTRAL_URL } from '../config';

export default function Login() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      window.location.href = `${LOGIN_CENTRAL_URL}/?app=helpdesk`;
    }
  }, [user]);

  // Si ya está logueado, no mostrar nada (evitar parpadeo/bucles).
  if (user) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
      <p className="text-sm text-gray-500 dark:text-gray-400">Redirigiendo al inicio de sesión...</p>
    </div>
  );
}
